<template>
  <div class="page-add">
    <div class="add-title">编辑问卷</div>
    <QuestionForm 
      :defaultForm="questionnaireForm"
      :submitApi="api" />
  </div>
</template>

<script>
import { getQuestionnaireInfo, updateQuestionnaire } from "@/api/questionnaire";
import QuestionForm from '../component/questionForm.vue'

export default {
  name: "questionnaireEdit",
  components: { QuestionForm },
  data() {
    return {
      questionnaireForm: null,
      api: updateQuestionnaire,
    };
  },
  computed: {
  },
  created() {
    this.getQuestionnaireInfo()
  },
  watch: {
  },
  methods: {
    getQuestionnaireInfo() {
      getQuestionnaireInfo(this.$route.query.id).then((res) => {
        if (!res || res.code != 0) return;
        this.questionnaireForm = res.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
